// 문서 목록 — 정적 원장 (원고 원본: docs/guides/, slug = 파일명)
//
// 2026-09-06 부터 이 목록은 두 곳에서만 쓰인다.
//   1) REACT_APP_DOCS_FEED_URL 이 없는 빌드(정적 모드)와 프리뷰 빌드 — docs/DocsContext.jsx 가 이 목록을 쓴다
//   2) scripts/make-manifest.js — 레이 챗봇(lay-docs-chat, origin 모드)이 읽는 manifest.json 의 원천
// 피드 모드에서는 admin 「레이블리 가이드」 표(lay_docs_guide)가 원장이고 이 파일은 읽히지 않는다.
// 전환이 끝나(인수인계 문서 §3-3 ④) 정적 발행을 끊는 날 이 목록과 public/content/ 를 함께 지운다.
// audience: 'creator' | 'rights'. 두 역할 모두 볼 문서는 둘 다 적는다.
// 관리자(Admin/Master/Manager)는 항상 전체를 본다 — 내부 직원용 'staff'(사이트 전용)·'internal'(레이도 답함) 문서까지.
// 크리에이터 겸 영상권리사 겸직(all)은 두 대상 가이드를 다 보지만 내부 직원용 둘은 못 본다(2026-10-15).
// BOTH(두 대상 공용)는 2026-09-07 변경 이력 분리로 쓰는 곳이 없어졌다.
// 두 대상이 함께 보는 문서는 약관·개인정보처리방침뿐이고 그건 BOTH_PUB 이다.
const C = ['creator'];
const R = ['rights'];
const BOTH = ['creator', 'rights'];

// 로그인 전에도 열리는 문서. 회원가입 화면과 승인 안내 메일이 이 주소를 가리키므로,
// 아직 승인받지 못한 사람도 가입 절차와 약관은 읽을 수 있어야 한다.
// 여기 넣는 기준은 "가입을 결정하는 데 필요한가" 다 — 서비스 화면·기능 설명은
// 넣지 않는다(로그인해야 볼 수 있는 화면을 설명해 봐야 쓸모도 없다).
// 나머지 문서는 승인 후 로그인해야 보인다.
const PUBLIC = 'public';
const C_PUB = ['creator', PUBLIC];
const BOTH_PUB = ['creator', 'rights', PUBLIC];
export const PUBLIC_AUDIENCES = new Set([PUBLIC]);

const nav = [
  { group: '시작하기', items: [
    { slug: 'c-start', title: '가입·승인·로그인', audience: C_PUB },
    { slug: 'c-tour', title: '화면 둘러보기', audience: C },
    { slug: 'c-onboard', title: '온보딩 순서 한 장으로 보기', audience: C },
    { slug: 'c-app', title: '레이블리 앱 사용하기', audience: C },
    { slug: 'c-contract', title: '계약과 해지', audience: C },
    { slug: 'c-faq', title: '자주 묻는 질문', audience: C },
    { slug: 'cr-lay', title: '레이(AI 도우미)에게 물어보기', audience: BOTH },
    { slug: 'r-r-start', title: '포털 접속·계정', audience: R },
  ] },
  { group: '채널', items: [
    { slug: 'c-channel', title: '채널 등록·연동', audience: C },
    { slug: 'c-brand', title: '브랜드 채널', audience: C },
    { slug: 'c-super', title: '슈퍼 채널', audience: C },
    { slug: 'c-cj', title: 'CJ ENM 협업 채널', audience: C },
    { slug: 'c-global', title: '해외 채널 운영', audience: C },
  ] },
  { group: '작품과 콘텐츠', items: [
    { slug: 'c-works', title: '작품 확인·사용 신청', audience: C },
    { slug: 'c-upload', title: '제작·업로드와 식별코드', audience: C },
    { slug: 'c-promo', title: '프로모션·번들 참여하기', audience: C },
    { slug: 'c-bundle', title: '번들 카드 읽는 법', audience: C },
    { slug: 'c-guideline', title: '작품 가이드라인 읽는 법', audience: C },
    { slug: 'c-inspect', title: '검수 절차', audience: C },
    { slug: 'c-rules', title: '협업 전 꼭 알아야 할 6가지', audience: C },
    { slug: 'c-academy', title: '레이블리 아카데미 — 유튜브 쇼츠 8주 과정', audience: C },
    { slug: 'c-copyright', title: '저작권 보호와 클레임 대응', audience: C },
  ] },
  { group: '작품 관리', items: [
    { slug: 'r-r-works', title: '작품 등록·제공 조건', audience: R },
  ] },
  { group: '검수와 평가', items: [
    { slug: 'r-r-review', title: '검수하고 별점 남기기', audience: R },
    { slug: 'r-r-reject', title: '반려 사유 고르기', audience: R },
    { slug: 'r-r-faq', title: '권리사 FAQ', audience: R },
  ] },
  { group: '협업 채널', items: [
    { slug: 'r-r-pick', title: '협업 채널 고르기', audience: R },
  ] },
  { group: '수익과 정산', items: [
    { slug: 'c-revenue', title: '수익 확인', audience: C },
    { slug: 'c-settle', title: '정산 신청과 내역서', audience: C },
    { slug: 'r-r-settle', title: '정산내역서·신청 절차', audience: R },
  ] },
  { group: '숏폼 수익 배분 정책', items: [
    { slug: 'c-sf-policy', title: '숏폼 수익 배분 정책', audience: C },
    { slug: 'c-sf-calc', title: '숏폼 수익 계산 방식', audience: C },
  ] },
  { group: '플랫폼별 운영 · 네이버 클립', items: [
    { slug: 'c-nv-start', title: '네이버 클립 시작하기', audience: C },
    { slug: 'c-nv-policy', title: '네이버 클립 운영 정책', audience: C },
  ] },
  { group: '플랫폼별 운영 · 카카오 숏폼', items: [
    { slug: 'c-kk-start', title: '카카오톡 숏폼 시작하기', audience: C },
    { slug: 'c-kk-policy', title: '카카오톡 숏폼 운영 정책', audience: C },
  ] },
  { group: '등급제', items: [
    { slug: 'c-tier-overview', title: '등급제란 무엇인가요', audience: C },
    { slug: 'c-tier-screen', title: '내 등급 화면 보는 법', audience: C },
    { slug: 'c-tier-when', title: '언제 정해지나요', audience: C },
    { slug: 'c-tier-scoring', title: '무엇이 평가되나요', audience: C },
    { slug: 'c-tier-moves', title: '등급은 어떻게 오르고 내리나요', audience: C },
    { slug: 'c-tier-faq', title: '등급제 FAQ', audience: C },
    // 2026-09-21 — 결제·구독 시행(10/1~) 안내. 표(lay_docs_guide)에는 라이브 전환 당일 insert(docs/ops/toss-payments-guide-c-plan-insert.sql)
    { slug: 'c-plan', title: '멤버십 구독료 안내', audience: C },
  ] },
  { group: '약관·정책', items: [
    { slug: 'cr-terms', title: '이용약관', audience: BOTH_PUB },
    { slug: 'cr-privacy', title: '개인정보처리방침', audience: BOTH_PUB },
    // 2026-09-07 — 한 문서에 두 대상 변경이 섞여 있어(110행 중 권리사 3행) 대상별로 갈랐다.
    { slug: 'cr-changelog', title: '변경 이력', audience: C },
    { slug: 'r-r-changelog', title: '변경 이력 (영상권리사)', audience: R },
  ] },
  // 관리자 가이드 (2026-09-24 신설) — 내부 직원용(staff), 관리자만 본다. docs-feed 는 관리자가 아니면 목록에서도 뺀다
  { group: '운영팀 가이드', items: [
    { slug: 's-prerelease', title: '본방 전 소재 계약 운영하기', audience: ['staff'] },
  ] },
];

export const flat = nav.flatMap((g) => g.items.map((i) => ({ ...i, group: g.group })));
export const bySlug = Object.fromEntries(flat.map((p) => [p.slug, p]));

export function isPublic(page) {
  return page.audience.includes(PUBLIC);
}

// 이 사람이 이 문서를 볼 수 있나 — 서버 docs-feed 의 pageVisible 과 **같은 규칙**이어야 한다.
// 한쪽만 바꾸면 정적 모드와 피드 모드가 다른 목록을 보여 준다.
//
// 🔴 `public` 은 **로그인 전 전용** 이다(2026-09-07 정정). 예전에는 `public` 이 붙은 문서를
// scope 검사보다 먼저 통과시켜, 크리에이터용 「가입·승인·로그인」(creator+public)이
// **영상권리사에게도** 보였다 — 두 대상을 섞어 보여 준 주된 경로였다.
// 로그인한 사람에게는 자기 대상(creator/rights)이 붙은 문서만 보인다.
export function canView(page, audiences) {
  if (!audiences) return false;
  if (page.audience.includes('staff')) return audiences.has('staff');       // 내부 직원용(사이트 전용)은 내부 직원만 (2026-09-10 · 겸직 제외 2026-10-15)
  if (page.audience.includes('internal')) return audiences.has('internal'); // 내부 운영 매뉴얼(레이도 답함)은 내부 직원만 (2026-10-15)
  const creator = audiences.has('creator');
  const rights = audiences.has('rights');
  if (creator && rights) return true;              // 관리자·겸직 = 두 대상 가이드 전체(내부용은 위에서 걸렀다)
  // 파트너: 파트너 문서 + 크리에이터·권리사 가이드 전부(내부용 둘만 위에서 제외) — 대표 결정 2026-09-10 · 서버 docs-feed pageVisible 과 같은 규칙
  if (audiences.has('partner')) return true;
  if (!creator && !rights) return page.audience.includes(PUBLIC); // 비로그인 = 공개 문서만
  const mine = creator ? 'creator' : 'rights';
  return page.audience.includes(mine);
}

// 문서의 대상 한 줄 요약 — 사이드바 구획·배지에 쓴다.
// 'both' 는 두 대상이 함께 보는 문서(약관 등), 'public' 은 로그인 전에도 열리는 문서다.
export function audienceOf(page) {
  const a = page.audience || [];
  if (a.includes('staff') || a.includes('internal')) return 'staff'; // 사이드바 구획은 둘 다 「내부」
  if (a.includes('partner') && !a.includes('creator') && !a.includes('rights')) return 'partner';
  const creator = a.includes('creator');
  const rights = a.includes('rights');
  if (creator && rights) return 'both';
  if (rights) return 'rights';
  if (creator) return 'creator';
  return 'public';
}

export const AUDIENCE_LABEL = { creator: '크리에이터', rights: '영상권리사', partner: '파트너', staff: '내부', both: '공통', public: '공통' };

// 전체(관리자·겸직)로 볼 때 대상별로 갈라 준다 — 한 화면에 두 대상이 섞이지 않게.
// 자기 대상만 보는 사람에게는 구획이 하나뿐이라 종전과 같은 화면이다.
export function sectionsFrom(pages, groupsOf) {
  const order = ['creator', 'rights', 'partner', 'staff', 'both'];
  return order
    .map((key) => ({
      audience: key,
      label: AUDIENCE_LABEL[key],
      groups: groupsOf(pages.filter((p) => audienceOf(p) === key || (key === 'both' && audienceOf(p) === 'public'))),
    }))
    .filter((s) => s.groups.length > 0);
}

// 역할에 맞는 트리/평면 목록. 빈 그룹은 통째로 숨긴다.
export function navFor(audiences) {
  return nav
    .map((g) => ({ ...g, items: g.items.filter((i) => canView(i, audiences)) }))
    .filter((g) => g.items.length > 0);
}

export function flatFor(audiences) {
  return flat.filter((p) => canView(p, audiences));
}

// 평면 목록에서 그룹 트리를 만든다 — 순서는 목록 순, 그룹은 처음 나온 자리에. 피드 모드의 목록에도 쓴다.
export function groupsFrom(pages) {
  const groups = [];
  const byName = new Map();
  pages.forEach((p) => {
    let g = byName.get(p.group);
    if (!g) { g = { group: p.group, items: [] }; byName.set(p.group, g); groups.push(g); }
    g.items.push(p);
  });
  return groups;
}

// 서버(docs-feed)가 판정한 scope → 화면이 쓰는 audiences. audiencesFromRole(AuthContext) 과 짝이다.
// 🔴 PUBLIC 을 넣지 않는다 — 넣으면 canView 가 「공개 문서는 누구에게나」로 되돌아가
// 권리사에게 크리에이터 문서가 다시 샌다(2026-09-07). 비로그인만 PUBLIC_AUDIENCES 를 쓴다.
export function audiencesFromScope(scope) {
  const set = new Set();
  if (scope === 'all' || scope === 'internal' || scope === 'creator') set.add('creator');
  if (scope === 'all' || scope === 'internal' || scope === 'rights') set.add('rights');
  // 내부 직원(internal)만 내부용 둘을 받는다. 겸직(all)은 받지 않는다 — 2026-10-15 전에는 all 에 staff 가 들어가 외부 겸직자에게 관리자 가이드가 보였다.
  if (scope === 'internal') { set.add('staff'); set.add('internal'); }
  if (scope === 'partner') set.add('partner');
  if (set.size === 0) set.add(PUBLIC);
  return set;
}

export default nav;
